import { render, staticRenderFns } from "./AccountStatusTable.vue?vue&type=template&id=65c1649e&scoped=true&"
import script from "./AccountStatusTable.vue?vue&type=script&lang=js&"
export * from "./AccountStatusTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=65c1649e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c1649e",
  null
  
)

export default component.exports